"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { DropdownUI } from '../../DropdownUI/index.mjs';
import { SvgIcon } from '../../SvgIcon/index.mjs';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { useComboBox } from '../context/use-combobox.mjs';
import { useComboBoxDropdownContext } from '../context/use-combobox-dropdown.mjs';
import { useComboBoxDropdownSearchContext } from '../context/use-combobox-dropdown-search.mjs';
import { dropdownCategoryConfig } from '../shared.mjs';

const SearchInput = forwardRef(({ autoFocus }, ref) => {
  const { activeCategory } = useComboBoxDropdownContext();
  const { hideSearch } = useComboBoxDropdownSearchContext();
  if (activeCategory && dropdownCategoryConfig[activeCategory]?.hideSearchInput) {
    return null;
  }
  if (hideSearch) {
    return null;
  }
  return /* @__PURE__ */ jsx(DropdownSearchComponent, { autoFocus, ref });
});
const DropdownSearchComponent = forwardRef(({ autoFocus }, ref) => {
  const { value: parentInputValue, onValueChange: setParentValue } = useComboBox();
  const { canUseParentInputSearchValue } = useComboBoxDropdownContext();
  const { dropdownSearchInputValue, setDropdownSearchInputValue, setSearchSource } = useComboBoxDropdownSearchContext();
  const hasParentInputSearch = !!parentInputValue && typeof parentInputValue === "string" && canUseParentInputSearchValue;
  const hasDropdownInputSearch = dropdownSearchInputValue && typeof dropdownSearchInputValue === "string";
  const hasSearchValue = hasParentInputSearch || hasDropdownInputSearch;
  const handleClear = () => {
    if (hasParentInputSearch) {
      setParentValue?.("");
    }
    if (hasDropdownInputSearch) {
      setDropdownSearchInputValue("");
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "flex gap-0 justify-between items-center", children: [
      /* @__PURE__ */ jsx(
        DropdownUI.Search,
        {
          ref,
          value: dropdownSearchInputValue,
          onChange: setDropdownSearchInputValue,
          autoFocus,
          placeholder: canUseParentInputSearchValue ? parentInputValue : void 0,
          onFocus: () => setSearchSource("dropdown-search-input")
        }
      ),
      hasSearchValue && /* @__PURE__ */ jsx(DropdownUI.ClearSearchButton, { onClick: handleClear, children: /* @__PURE__ */ jsx(SvgIcon, { type: SvgIconType.Close }) })
    ] }),
    /* @__PURE__ */ jsx(DropdownUI.SearchDivider, {})
  ] });
});

export { SearchInput };
